import React from 'react';
import './DragAndDrop.css';

function GetPlaceholderAndContainerStyle(props) {
    const placeholder = (props.items && props.items.length > 0) ? null : props.placeholder;
    const containerStyle = { minHeight: placeholder ? props.minHeight : null, flexGrow: props.flexGrow };
    
    return {
        placeholder: placeholder,
        containerStyle: containerStyle
    };
}

const DragAndDrop = (props) => {
    const { placeholder, containerStyle } = GetPlaceholderAndContainerStyle(props);
   
    let list = React.createRef();
    return (
        <ul
            ref={list}
            className={props.containerClass}
            data-placeholder={placeholder}
        >
            <div style={containerStyle} />
        </ul>
    );
}

export default DragAndDrop;





// WEBPACK FOOTER //
// ./src/components/DragAndDrop/DragAndDrop.js